import { FC } from 'react';
import clsx from 'clsx';
import { all, collectBy, pipe, prop, reject } from 'ramda';
import { Box } from '../../../../../../../Box';
import { ContentGroupsProps, InnerOption } from '../../../../../../types';
import { ContentRows } from '../ContentRows';
import { GroupHeader } from '../GroupHeader';

import styles from './index.module.css';

export const ContentGroups: FC<ContentGroupsProps> = ({
  options,
  groupBy,
  groupsData = {},
  value,
  onRowSelect,
  size,
  className,
  classNames,
  dataRole,
  intentType
}) => {
  const byGroup: (value: InnerOption) => PropertyKey = prop(groupBy);
  const isHidden = pipe(prop('hidden'), Boolean);

  const groups = pipe(
    collectBy(byGroup), // don't use groupBy to preserve order according to spec
    reject(all(isHidden)) // reject groups that have all their items hidden
  )(options);

  return (
    <>
      {groups.map((group) => {
        const { [groupBy]: groupKey } = group[0];
        const { title, iconElement } = groupsData[groupKey];

        return (
          <Box
            key={groupKey}
            direction="column"
            className={clsx(className, styles.groupContainer)}
          >
            <GroupHeader title={title} iconElement={iconElement} size={size} />
            <ContentRows
              options={group}
              value={value}
              onRowSelect={onRowSelect}
              size={size}
              intentType={intentType}
              className={clsx(styles.groupContent, classNames?.groupContentRow)}
              dataRole={dataRole}
            />
          </Box>
        );
      })}
    </>
  );
};
